import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn's class merger.
 *
 * `clsx` resolves conditionals, `tailwind-merge` makes the LAST conflicting
 * utility win — so a caller passing `className="p-6"` to a component whose
 * default is `p-4` gets 6, not both. Without it every component would need its
 * own override plumbing.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
